import {  Component, Vue } from "vue-property-decorator"
import { financeMarketCostStatisticalData, financeMarketCostStatisticalDataExport } from '@/api/financial-center'
import { delNullProperty } from '@/utils/index'
import {UserModule} from "@/store/modules/user";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import commonData from "@/utils/commonData";

const projectTypeFilter = commonData.projectTypeArray
@Component({
  components:{
    MoreUsersFilter
  }
})
export default class OrderStatisticsData extends Vue {

  page = 1
  limit = 20
  total = 0
  dissertationType = ''
  souCourseName = ''
  souCourseSchoolBegin = []
  tableData = []
  tableLoading = false
  popover1 = false
  popover2 = false
  popover3 = false
  exportButtonDisabled = false
  customerName = ''
  status = ''
  marketCooperationName = ''
  types = ''
  timer = null
  // isReadonly = false
  payStatus = '' // 打款状态
  projectTypeFilter = projectTypeFilter //项目类型
  souCourseTypeId = ''
  createdUserId = ''
  financeOrderCreatedUserIdList = []
  reason =  '' //申请原因
  financeOrderCode = '' // 订单编号

  created() {
    this.getTableData()
  }

  pageChange(page: number) {
    if (this.timer !== null) clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.page = page
      this.getTableData()
    }, 1000)
  }
  // computed

  async getTableData() {
    this.popover1 = false
    this.popover2 = false
    this.popover3 = false
    this.tableLoading = true

    const { allNum, financeMarketCostList } = await financeMarketCostStatisticalData(delNullProperty({
      limit: this.limit,
      page: this.page,
      customerName : this.customerName,
      status: this.status,
      marketCooperationName : this.marketCooperationName,
      types : this.types,
      payStatus : this.payStatus,
      financeOrderCreatedUserIdList : this.financeOrderCreatedUserIdList,
      souCourseTypeId : this.souCourseTypeId,
      reason : this.reason,
      financeOrderCode : this.financeOrderCode,
    })) as unknown as { allNum: number; financeMarketCostList: any[] }
    this.tableData = financeMarketCostList
    this.total = allNum
    this.tableLoading = false
    // this.isReadonly = false
  }

  async exportExcel() {
    this.exportButtonDisabled = true
    this.$message.success('数据已转入后台导出, 请前往下载列表查看')
    await financeMarketCostStatisticalDataExport(delNullProperty(
        {
          customerName: this.customerName,
          status: this.status,
          marketCooperationName: this.marketCooperationName,
          types: this.types,
          payStatus: this.payStatus,
          financeOrderCreatedUserIdList: this.financeOrderCreatedUserIdList,
          souCourseTypeId: this.souCourseTypeId,
          reason: this.reason,
          financeOrderCode: this.financeOrderCode,
        })
    )
    this.exportButtonDisabled = false
  }

  // pageChange(page: number) {
  //   this.page = page
  //   this.getTableData()
  // }

  pageSizeChange(limit: number) {
    this.limit = limit
    this.getTableData()
  }

  changeFinanceOrderCreatedUserIdList(e) {
    this.financeOrderCreatedUserIdList = e.id
    this.page = 1
    this.getTableData()
  }

}
